<div class="current-price" [ngClass]="{'strikethrough': isItemCut || false }" >{{ _formattedPrice }}</div>
